<template>
    <div>
        <section class="aj-header">
            <div class="circle-animation">
                <div class="circle1"></div>
                <div class="circle2"></div>
                <div class="hexa"></div>
            </div>
            <div class="aj-vector-left">
                <div class="aj-bg2"></div>
            </div>
            <div class="aj-vector-right">
                <div class="aj-bg1"></div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <form action="">
                            <div class="col-md-8">
                                <div class="aj-abso">
                                    <div class="search-box">
                                        <div class="aj-search-heading">Search & Grab The Best Opportunities</div>
                                        <form @submit.prevent="search">
                                            <div class="search-bar">
                                                <input type="text" placeholder="Search Jobs" v-model="searchkey">
                                                <button type=""><i class="fas fa-search"></i></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="main-heading">All Jobs</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4" v-for="j in jobscont">
                        <div class="job-box">
                            <div class="jb-com-icon">
                                <img v-bind:src="j.logo" alt="">
                            </div>
                            <div class="jb-com-name" v-html="j.name">
                            </div>
                            <div class="jb-job-title">
                                <span v-html="j.title"></span>
                                <div v-if="j.is_exclusive" class="tooltip-main labelImg display-inline-block">
                                    <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                    <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                </div>
                            </div>
                            <div class="location">
                                <i class="fas fa-map-marker-alt"></i> {{j.location}}
                            </div>
                            <div class="jb-job-positions">
                                {{j.positions}} positions
                            </div>
                            <div class="jb-view-details">
                                <router-link :to="{path: '/detail?id=' + j.slug}">
                                    View Job Detail
                                </router-link>
                                <div v-if="j.filling_soon" class="tooltip-main labelImg display-inline-block">
                                    <img src="images/all-jobs/filling-soon.png" width="15" hspace="5"/>
                                    <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                                </div>
                                <!--<a v-bind:href="j.link">View Job</a>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="!searchLoading && !jobscont.length">
                        <h4>No Jobs found in this keyword</h4>
                    </div>
                    <div class="col-md-12" v-if="searchLoading && !jobscont.length">
                        <div style="height: 350px;">
                            <div class="loading-list"></div>
                            <div class="loading-list-ring"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import axios from 'axios'
    import {requestHeaders} from "../_helpers/apiHelper";

    export default {
        data: function () {
            return {
                jobscont: [],
                searchkey: '',
                bottom: false,
                searchLoading: false,
                page: 1,
                request: true,
            }
        },
        mounted() {
            // if(this.userType && this.userType != 'Individual'){
            //     this.$router.push({path: '/'})
            // }
            var url = this.$store.getters.getDomain;

            var a = this;
            var bodyFormData = new FormData();
            if (this.$route.query.slug) {
                bodyFormData.set('slug', this.$route.query.slug);
            }
            a.searchLoading = true;
            axios({
                method: 'POST',
                url: `${url}api/v2/search/jobs`,
                headers: requestHeaders(),
                data: bodyFormData,
            }).then(function (response) {
                a.searchLoading = false;
                if (response['data']['response']) {
                    for (var i = 0; i < response['data']['response'].length; i++) {
                        a.jobscont.push(response['data']['response'][i])
                    }
                } else {
                    a.request = false;
                }
            })
                .catch(function (error) {
                    console.log(error)
                })

        },
        methods: {
            search() {
                var url = this.$store.getters.getDomain;
                var a = this;
                a.page = 1;
                a.searchLoading = true;
                var bodyFormData = new FormData();
                bodyFormData.set('keyword', a.searchkey);
                bodyFormData.set('page', a.page);
                window.history.pushState("", "", "/jobs?keyword="+a.searchkey);
                a.jobscont = [];

                axios({
                    method: 'POST',
                    url: `${url}api/v2/search/jobs`,
                    headers: requestHeaders(),
                    data: bodyFormData,
                })
                    .then(function (response) {
                        a.searchLoading = false;
                        if (response['data']) {
                            for (var i = 0; i < response['data']['response'].length; i++) {
                                a.jobscont.push(response['data']['response'][i])
                            }
                            if (a.bottomVisible()) {
                                a.page += 1
                                a.addList()
                            }
                            a.request = true;
                        } else {
                            a.request = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            },
            bottomVisible() {
                if (document.getElementsByClassName('footer').length > 0) {
                    const scrollY = window.scrollY
                    const visible = document.documentElement.clientHeight
                    const pageHeight = document.documentElement.scrollHeight - document.getElementsByClassName('footer')[0].clientHeight;

                    const bottomOfPage = visible + scrollY >= pageHeight
                    return bottomOfPage || pageHeight < visible
                }
            },
            addList() {
                if (this.request) {
                    var url = this.$store.getters.getDomain;

                    var a = this;
                    a.searchLoading = true
                    var bodyFormData = new FormData();
                    if (this.searchkey) {
                        bodyFormData.set('keyword', this.searchkey);
                    }
                    bodyFormData.set('page', a.page);

                    axios({
                        method: 'POST',
                        url: `${url}api/v2/search/jobs`,
                        headers: requestHeaders(),
                        data: bodyFormData,
                    }).then(function (response) {
                        a.searchLoading = false
                        if (response['data']) {
                            for (var i = 0; i < response['data']['response'].length; i++) {
                                a.jobscont.push(response['data']['response'][i])
                            }
                            if (a.bottomVisible()) {
                                a.page += 1;
                                a.addList()
                            }
                        } else {
                            a.request = false;
                        }
                    })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            }
        },
        watch: {
            bottom(bottom) {
                if (bottom) {
                    this.page += 1;
                    this.addList()
                }
            }
        },
        created() {
            window.addEventListener('scroll', () => {
                this.bottom = this.bottomVisible()
            })
        }
    }
</script>